export default __webpack_public_path__ + "static/media/activeArrowLeftDark.2783903b.svg";